import { CONTACT_EMAIL } from "@/lib/contact";
import { Link } from "@/router";

/**
 * The dark band that closes every page.
 *
 * On the home page it carries the closing call to action; on /contact it does
 * not, because asking somebody to go to the contact page while they are
 * filling in the contact form is the kind of thing that makes a site feel
 * assembled rather than written. Hence the `cta` switch instead of two
 * near-identical components.
 */
export function SiteFooter({ cta = false }: { cta?: boolean }) {
  return (
    <section className="k-band k-band--ink">
      <div className="k-shell k-sec">
        {cta && (
          <div className="k-gate">
            <h2>
              Get your{" "}
              <span className="k-mark k-mark--amber">second opinion.</span>
            </h2>
            <Link className="k-btn" href="/contact">
              Contact Keglam Services
            </Link>
          </div>
        )}

        <footer className={cta ? "k-foot" : "k-foot k-foot--bare"}>
          <span>Keglam Services, L.L.C.</span>
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </footer>
      </div>
    </section>
  );
}
